import getDFPBlock from "../utils/getDFPBlock";

export default function (newsId, elemCount, newsIndex, opt) {
    let wrapperId = 'adv' + newsId + elemCount;
    let advWrapper = document.getElementById(wrapperId);

    if(opt.isMarketplace && opt.subsiteName === 'education'){
        if (advWrapper !== null && advWrapper.childNodes.length === 0) {
            advWrapper.remove();
        }

        return;
    }

    if (advWrapper !== null && advWrapper.childNodes.length === 0) {
        let promoblockWrapper = document.getElementById('div-gpt-ad-1438691081622-0');
        if (promoblockWrapper !== null && promoblockWrapper.childNodes.length === 0 && window.innerWidth <= 640) {
            getDFPBlock('/56301415/24tv_promoArticle', [1, 1], 'div-gpt-ad-1438691081622-0',
                '300px',
                function () {
                    let promoBlock = document.getElementById("newsListPromoArticle");
                    document.getElementById(wrapperId).appendChild(promoBlock)
                },
                {
                    id: '/56301415/24tv_in_news_mobile_third',
                    size: [300, 250],
                    wrapper: wrapperId
                })
        } else if (window.innerWidth <= 640) {
            getDFPBlock('/56301415/24tv_in_news_mobile_third', [300, 250], wrapperId)
        }

        if (window.innerWidth > 640) {
            getDFPBlock('/56301415/24tv_in_news_desktop_third', [580, 400], wrapperId, '580px')
        }
    }
}